import { render, staticRenderFns } from "./ReassignItemsPanel.vue?vue&type=template&id=95975e6c&scoped=true"
import script from "./ReassignItemsPanel.vue?vue&type=script&lang=js"
export * from "./ReassignItemsPanel.vue?vue&type=script&lang=js"
import style0 from "./ReassignItemsPanel.vue?vue&type=style&index=0&id=95975e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95975e6c",
  null
  
)

export default component.exports